<span class="truncate">
  {{ processedValue() }}
</span>
